import { Captions } from '~components/Typography';
import { Checkbox } from '~shared/ui/atoms/Checkbox';

import { Container } from './styles';

type IProps = {
	checked?: boolean;
	children: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	name?: string;
};

export const CheckboxRow = ({ checked, children, onChange, name }: IProps) => (
	<Checkbox
		name={name}
		checked={checked}
		onChange={onChange}
		className={Container}
	>
		<Captions size="L" color="grey-95-solid" align="left">
			{children}
		</Captions>
	</Checkbox>
);
